import { Observable } from 'rxjs';
import { Timeline, TimelineInfoMessage } from './timeline.models';

/**
 * @ignore
 */
export abstract class TimelineApiService {
  abstract loadTimeline(): Observable<Timeline>;
  abstract infoMessageDone(infoMessage: TimelineInfoMessage): Observable<any>;
  abstract saveForm(formId: any, data: any): Observable<any>;
}
